module.exports = __webpack_public_path__ + "static/media/ios-clock.eefa347b.svg";